<template>
    <div style="display: flex; flex-direction: column;">
        <ModalHeader :is-show-back-btn="is_show_back_btn" title="계약서"  />
        <div style="flex: 1;" v-if="!img_base64str && is_loaded && !is_submitted">
            <iframe src="/view/contract_agreement_contents" style="width:100%; height:100%; border:0px;" ref="agreement_contents_iframe_contract"></iframe>
        </div>
        <div style="flex:1; overflow: auto;" v-else-if="img_base64str && is_loaded">
            <img :src="img_base64str" style="width:100%;">
        </div>
        <!-- <div style="padding:10px; border-top:1px solid #ddd;"  v-if="mode === CONTRACT_AGREEMENT_MODE.INSERT && !is_submitted">
            <ProgressButton buttonText="제출" :showProgress="isSubmitting" @click="submit" style="margin-top:0px;" />
        </div>
        <div v-if="mode === CONTRACT_AGREEMENT_MODE.INSERT && is_submitted" style="display:grid;place-items: center;">
            <div style="margin-top:50px;">임시직 근로계약 및 동의서를 제출하셨습니다.</div>
        </div> -->
    </div>
</template>

<script>
import ModalHeader from "@/components/common/ModalHeader";
// import ProgressButton from "@/components/common/ProgressButton";
import ResponseCode from "../../ResponseCode";

export const CONTRACT_AGREEMENT_MODE = {
    VIEW : 0,
    INSERT : 1,
}

export default {
    name: "ContractAgreement",
    components: {
        ModalHeader,
    },
    props : {
        mode : {
            type : Number,
            default : CONTRACT_AGREEMENT_MODE.INSERT,
        },
        is_show_back_btn : {
            type : Boolean,
            default : true
        }
    },
    data() {
        return {
            CONTRACT_AGREEMENT_MODE : CONTRACT_AGREEMENT_MODE,
            isSubmitting: false,
            img_base64str: '',
            is_submitted : false,
            is_loaded : false,
            query : '',
        }
    },
    methods: {
        async submit() {
            const iframe_target = this.$refs.agreement_contents_iframe_contract.contentDocument;
            const checkbox_arr_str = iframe_target.getElementById('checkbox_arr_str_contract').value;
            const checkbox_arr = JSON.parse(checkbox_arr_str)
            
            if (checkbox_arr.pay_type === '') {
                this.$GlobalStore.showAlert('임금 지급 방식을 선택해주세요.')
                return
            } else if (checkbox_arr.isAgree === '') {
                this.$GlobalStore.showAlert('개인정보 수집 및 이용에 동의해주세요')
                return
            } else if (!checkbox_arr.isSigned1) {
                this.$GlobalStore.showAlert('개인정보 수집 및 이용에 서명해주세요')
                return
            } else if (!checkbox_arr.isSigned2) {
                this.$GlobalStore.showAlert('안전준수 서약에 서명해주세요')
                return
            }
            this.isSubmitting = true;

            const scrollHeight = checkbox_arr.pageHeight
            /*eslint-disable no-undef */
            const canvas = await html2canvas(iframe_target.querySelector('#agreement_contents_print_wrap_contract'), {
                scale: 2,
                height: scrollHeight,
                windowHeight: scrollHeight,
                scrollX: 0,
                scrollY: 0,
            });

            const base64str = canvas.toDataURL('image/png').replace('data:image/png;base64,', '');
            const parameters = {};
            parameters.agreement_image = base64str;
            const res = await this.$Axios.post('/api/agreement/work/save', parameters);
            this.isSubmitting = false;
            if(res.data.code === ResponseCode.SUCCESS){
                this.is_submitted = true;
                this.is_loaded = false;
            }else if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg);
            }
            // this.img_base64str = canvas.toDataURL('image/png');


            // const imgWindow = window.open();
            //     imgWindow.document.write(`
            //         <html>
            //         <head><title>이미지 미리보기</title></head>
            //         <body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh; background:#f0f0f0;">
            //             <img src="${this.img_base64str}" style="max-width:100%; max-height:100%;" />
            //         </body>
            //         </html>
            //     `);
        },
        async getAgreement(){
            const parameters = {};
            const res = await this.$Axios.get('/api/agreement/work', {params : parameters});
            if(res.data.code === ResponseCode.FAIL){
                this.$GlobalStore.showAlert(res.data.msg);
                return;
            } else if(res.data.code === 1){
                if(this.mode === CONTRACT_AGREEMENT_MODE.INSERT){
                    this.is_loaded = true;
                    return;
                } else if(this.mode === CONTRACT_AGREEMENT_MODE.VIEW){
                    this.$GlobalStore.showAlert('저장된 임시직 근로계약 및 동의서가 없습니다.');
                }
                return;
            }

            if(this.mode === CONTRACT_AGREEMENT_MODE.INSERT){
                this.is_loaded = true;
                this.is_submitted = true;
            } else {
                this.is_loaded = true;
                this.img_base64str = 'data:image/png;base64,' + res.data.image_data_str;
            }

        }
    },
    created() {
        this.submit = this.$Once(this.submit);

        this.getAgreement();
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
}


select {
    width: 100%;
    padding: 0px 6px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    height: 44px;
    background-color: white;
    color: black;
}

button {
    padding: 8px 16px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    height: 44px;
}

button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}
</style>